(() => {
  if (window.unrealPayPalBuyNowConnected) return;
  window.unrealPayPalBuyNowConnected = true;
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-unreal-paypal-buy-now]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();
    const form = button.closest('form');
    const message = form?.querySelector('[data-unreal-buy-message]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      if (!form || !form.reportValidity()) return;
      const fields = new FormData(form);
      const id = String(fields.get('id') || '');
      const quantity = Number(fields.get('quantity') || 1);
      if (!/^\d{10,20}$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 20) throw new Error('quantity');
      if (fields.get('selling_plan') || [...fields.entries()].some(([key, value]) => key.startsWith('properties[') && value)) throw new Error('options');
      const url = new URL(button.dataset.productUrl + '.js', location.origin);
      if (url.origin !== location.origin) throw new Error('url');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('product');
      const product = await response.json();
      const variant = product.variants.find(item => String(item.id) === id);
      if (!variant?.available || !Number.isSafeInteger(variant.price) || product.gift_card) throw new Error('variant');
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!cartResponse.ok || (await cartResponse.json()).currency !== 'AED') throw new Error('currency');
      const target = new URL('https://unreal-skin-paypal-checkout.dishantsahare666.chatgpt.site/cart');
      target.searchParams.set('items', id + ':' + quantity);
      target.searchParams.set('shop_total', String(variant.price * quantity));
      target.searchParams.set('shop_currency', 'AED');
      window.location.assign(target.href);
    } catch {
      if (message) { message.textContent = window.unrealPayPalBuyError; message.hidden = false; }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
